// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__S6Kh2","point":"styles_point__OYkJK","main_wrapper":"styles_main_wrapper__dBZ44"};